import { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { SearchIcon } from "../../components/icons";
import { KeyboardStep } from "./TotemStep";
import { setSearchText } from "../../ducks/productsSlice";

// Busca do totem: abre o teclado na tela cheia e grava o termo em
// products.searchText, que a home do totem usa no lugar do grupo ativo.
export default function TotemSearchButton() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [text, setText] = useState("");

  const handleOpenModal = () => {
    setText("");
    setShow(true);
  };
  const handleCloseModal = () => setShow(false);

  const onKeyboardChange = (input) => setText(input.trimStart());

  const onSearch = () => {
    setShow(false);
    dispatch(setSearchText({ searchText: text }));
  };

  const error = text.length > 0 && text.length < 3 ? "Mínimo 3 letras" : null;

  const disabled = text.length < 3;

  return (
    <>
      <button
        type="button"
        className="totem-pill-button"
        onClick={handleOpenModal}
      >
        <SearchIcon /> Buscar
      </button>
      <Modal
        show={show}
        backdrop="static"
        dialogClassName="totem-fullscreen-dialog"
        contentClassName="totem-fullscreen-dialog__content"
      >
        <KeyboardStep
          title="O que você procura?"
          value={text}
          placeholder="Nome do produto"
          onChange={onKeyboardChange}
          onBack={handleCloseModal}
          onConfirm={onSearch}
          disabled={disabled}
          error={error}
          confirmLabel="Buscar"
        />
      </Modal>
    </>
  );
}
